module.exports = __webpack_public_path__ + "assets/img/horizotalus-moguliu-isdestymas.adfe35e8.jpg";